import { useQuery } from '@tanstack/react-query';

import type { DeliveryCountry } from 'app/typings/WelcomeKit/deliveries';
import { apiRequest } from 'app/utils/request/api';

const path = '/gateway/hotel-logistics/countries' as const;

export function useDeliveriesCountries({ enabled = true } = {}) {
  return useQuery({
    queryKey: [path],
    queryFn: () =>
      apiRequest({
        path,
        queryParams: { deliveriesOpen: true },
      }) as Promise<DeliveryCountry[]>,
    meta: { errorMessage: 'Error fetching Delivery Countries' },
    staleTime: Infinity,
    enabled,
  });
}
